import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgTiktokIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.933.016c-3.408.243-6.621 1.53-9.197 3.688a15.808 15.808 0 0 0-4.067 5.15C.792 10.61.3 12.313.061 14.4c-.066.597-.066 2.603 0 3.2.238 2.085.731 3.79 1.608 5.547.88 1.76 2 3.261 3.411 4.57a15.62 15.62 0 0 0 3.773 2.614c1.758.877 3.462 1.37 5.547 1.608.597.066 2.603.066 3.2 0 2.085-.238 3.79-.731 5.547-1.608a15.378 15.378 0 0 0 4.173-3.008c.536-.536.819-.854 1.256-1.403a16.079 16.079 0 0 0 3.261-7.533c.134-.923.15-1.142.15-2.387s-.016-1.464-.15-2.387c-.397-2.72-1.594-5.464-3.312-7.6a16.114 16.114 0 0 0-4.309-3.765 18.68 18.68 0 0 0-2.27-1.12c-1.423-.563-2.72-.883-4.32-1.064-.28-.032-.68-.045-1.466-.05a49.556 49.556 0 0 0-1.227.002Zm4.667 5.31c0 .114.019.333.04.485a5 5 0 0 0 4.555 4.274l.365.032v3.598l-.379-.016a8.561 8.561 0 0 1-4.261-1.355l-.317-.208-.011 3.899c-.01 4.224-.005 4.061-.155 4.765a7.378 7.378 0 0 1-.8 1.992 7.509 7.509 0 0 1-.866 1.125 6.608 6.608 0 0 1-6.091 1.923 6.626 6.626 0 0 1-5.144-5.067 7.537 7.537 0 0 1-.096-2.253 6.62 6.62 0 0 1 3.68-5.096 6.697 6.697 0 0 1 1.88-.59c.333-.05 1.443-.069 1.741-.026l.152.021v1.84c0 1.011-.005 1.838-.01 1.838-.008 0-.112-.024-.235-.054-.97-.237-2.045.078-2.776.808a2.96 2.96 0 0 0-.864 1.968c-.03.667.133 1.256.496 1.795a2.98 2.98 0 0 0 3.816 1.016 2.992 2.992 0 0 0 1.49-1.704c.174-.493.163.03.163-7.952V5.12H19.6v.205Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTiktokStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTiktokIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TiktokIcon: any = SvgTiktokStyle;
export default TiktokIcon;
